import { Button, Col } from "antd";
import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { RoleClaim } from "../roleClaim";
import { UserRole } from "../userRole";
import { IRole, IRoleProps, IRoleStates } from "./interfaces";

export class Role extends EntityManager<IRole, IRoleProps, IRoleStates> {
    static initMetadata = (): IMetadata => {
        return {
            name: "Role",
            title: "نقش",
            Properties: [
                {
                    title: "نام",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نام را وارد نمایید' }]
                },
                {
                    title: "شرح",
                    dataIndex: "Description",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا شرح را وارد نمایید' }]
                },
                {
                    title: "فعال؟",
                    dataIndex: "IsActive",
                    propertyType: enmPropertyType.boolean,
                    controlType: enmControlType.checkbox,
                    filterable: true,
                    width: 150,
                }
            ]
        };
    }

    onInitializing() {

        this.visibleEditCommand = entity => entity.Id > 1;
        this.enableEditCommand = entity => entity.Id > 1;

        this.visibleDeleteCommand = entity => entity.Id > 1;
        this.enableDeleteCommand = entity => entity.Id > 1;

        this.renderingToolbar = () => {
            return (
                <>
                    <Col style={{ marginLeft: 10 }}>
                        <Button type="default" onClick={() => this.onRoleClaimsClick()}>دسترسی ها</Button>
                    </Col>
                    <Col style={{ marginLeft: 10 }}>
                        <Button type="default" onClick={() => this.onUsersClick()}>کاربر ها</Button>
                    </Col>
                </>);
        };
        this.searchArea = {
            columnsPerRow: 2
        };
        this.defaultSelectedRow = () => this.selectedEntity;
        this.searchable = true;
        this.preLoad = true;
    }
    onUsersClick() {
        this.addLookupForm("UserRole",
            <UserRole
                key="UserRole"
                preLoad={false}
                invokePath={this.metadata.title}
                isChildComponent={true}
                onClose={this.onLookupClosed}
                params={() => {
                    return { role: this.selectedEntity }
                }}
            />);
    }
    onRoleClaimsClick() {
        this.addLookupForm("RoleClaim",
            <RoleClaim
                key="RoleClaim"
                invokePath={this.metadata.title}
                isChildComponent={true}
                onClose={this.onLookupClosed}
                params={() => {
                    return { role: this.selectedEntity }
                }}
            />);
    }
}